import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content"/>}>
      <Switch>
        <Route path={`${APP_PREFIX_PATH}/home`} component={lazy(() => import(`./history`))} />
        <Route path={`${APP_PREFIX_PATH}/user-creator`} component={lazy(() => import(`views/app-views/users/wizard`))} />
        <Route path={`${APP_PREFIX_PATH}/user-updater`} component={lazy(() => import(`views/app-views/users/wizard/updater`))} />
        <Route path={`${APP_PREFIX_PATH}/users`} component={lazy(() => import(`views/app-views/users/list`))} />
        <Route path={`${APP_PREFIX_PATH}/chat`} component={lazy(() => import(`./chat`))} />
        <Route path={`${APP_PREFIX_PATH}/details/:bid/:subbid`} component={lazy(() => import(`./details`))} />
        <Route path={`${APP_PREFIX_PATH}/history`} component={lazy(() => import(`./history`))} />
        <Route path={`${APP_PREFIX_PATH}/bought`} component={lazy(() => import(`./bought`))} />
        <Route path={`${APP_PREFIX_PATH}/sold`} component={lazy(() => import(`./sold`))} />
        <Route path={`${APP_PREFIX_PATH}/bidding`} component={lazy(() => import(`./bidding`))} />
        <Route path={`${APP_PREFIX_PATH}/setting`} component={lazy(() => import(`./setting2`))} />
        <Route path={`${APP_PREFIX_PATH}/create-bid/:bid`} component={lazy(() => import(`./creator`))} />
        <Route path={`${APP_PREFIX_PATH}/logs`} component={lazy(() => import(`./log`))} />
        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/home`} />
      </Switch>
    </Suspense>
  )
}

export default React.memo(AppViews);